// extracted by mini-css-extract-plugin
export default {"ActionMiniContent":"ButtonActionMini_ActionMiniContent__nQbga"};